import React from "react";
import HelpModal from "common/HelpModal";

const Help = () => (
  <HelpModal
    title="External Bypass Devices Help"
    content={() => (
      <>
        <p>
          This window shows the mode of the bypass device that sends data
          traffic to the BQN server in normal circumstances and bypasses the BQN
          server when an error is detected. More than one bypass device is
          possible. All links of all devices are all in the same mode. Possible
          modes are:
        </p>
        <ul>
          <li>
            Normal: this is the normal enabled mode. The device sends traffic
            through the BQN and, if the BQN fails to answer, sends the traffic
            bypassing the BQN in order to preserve traffic connectivity.
          </li>
          <li>
            Forced bypass: the device activates the bypass path regardless of
            the BQN state. It is used to take the BQN server off the traffic
            during maintenance tasks (e.g. an upgrade requiring server reboots).
          </li>
          <li>Disabled: the bypass device is not configured.</li>
        </ul>

        <p>The fields in the table are as follows:</p>

        <ul>
          <li>
            <b>BQN</b>: Id of the BQN server the bypass device is connected to.
          </li>
          <li>
            <b>MODEL</b>: device model name.
          </li>
          <li>
            <b>SERIAL</b>: serial number of the device.
          </li>
          <li>
            <b>MODE</b>: device mode (enabled, forced bypass. disabled). See
            above for a detailed explanation of each mode.
          </li>
          <li>
            <b>LINKS-IN-BYPASS</b>: indicates the links in the device in bypass
            state.
          </li>
          <li>
            <b>ACTIONS</b>: Click on the{" "}
            <i className="material-icons valign-icon">edit</i> icon to edit the
            device mode
          </li>
        </ul>
        <p>
          Click on the <i className="material-icons valign-icon">refresh</i>{" "}
          icon to refresh status devices information.
        </p>
      </>
    )}
  />
);

export default Help;
